export const UserRole: {
    ADMIN: 'ADMIN',
    OPERATOR: 'OPERATOR',
    USER: 'USER',
    
    CUSTOMER: 'CUSTOMER',
} = {
    ADMIN: 'ADMIN',
    OPERATOR: 'OPERATOR',
    USER: 'USER',
    
    CUSTOMER: 'CUSTOMER',
};

export type UserRole = (typeof UserRole)[keyof typeof UserRole]